/**
 * Invio eventi al dataLayer di Google Tag Manager.
 *
 * Perche' non si usa `useGtm()` dei componenti: dal momento in cui GTM viene
 * installato in lazy (vedi `plugins/02.gtm.js`, fuori dal critical path per non
 * pesare sull'LCP), il plugin non esiste ancora quando gira il setup delle
 * pagine. `useGtm()` risolve su `globalProperties.$gtm` o sulla variabile
 * interna del plugin: prima dell'install entrambe sono vuote, quindi un
 * `const gtm = useGtm()` a livello di setup resta `undefined` per sempre e ogni
 * `gtm?.push()` successivo diventa un no-op silenzioso.
 *
 * Scrivendo direttamente sul dataLayer il problema non si pone: la coda esiste
 * indipendentemente dal plugin e GTM, quando si carica, processa gli eventi
 * gia' accodati. Il tracking torna completo senza rinunciare al lazy load.
 *
 * I payload replicano esattamente quelli che produceva `@gtm-support/core`,
 * cosi' i trigger e le variabili configurati in GTM continuano a combaciare.
 */

const DATA_LAYER_NAME = 'dataLayer'

const getDataLayer = () => {
  window[DATA_LAYER_NAME] = window[DATA_LAYER_NAME] || []
  return window[DATA_LAYER_NAME]
}

/**
 * Equivalente di `gtm.push()`: accoda il payload cosi' com'e'.
 */
export const pushDataLayer = payload => {
  if (!import.meta.client) return
  getDataLayer().push(payload)
}

/**
 * Equivalente di `gtm.trackEvent()`: mantiene le chiavi aggiuntive che la
 * libreria aggiungeva di default, per non alterare i dati che arrivano a GTM.
 */
export const trackEvent = ({
  event,
  category = null,
  action = null,
  label = null,
  value = null,
  noninteraction = false,
  ...rest
} = {}) => {
  pushDataLayer({
    'event': event ?? 'interaction',
    'target': category,
    'action': action,
    'target-properties': label,
    'value': value,
    'interaction-type': noninteraction,
    ...rest
  })
}
